export enum FORM_STATUS {
    add = 'ADD',
    edit = 'EDIT',
    detail = 'DETAIL',
    clone = 'CLONE'
};